/**
 * Created by Mark on 23/11/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants/assignments.js';
import HomeworkConstants from '../constants/homework.js';
import Actions from '../actions/default.js';


class AssignmentsService {

    createHomework(name , assigned ,  setDate , dueDate , language , vocab , games , moduleID){

        let gameObjs = games.map(function(game){
            return {value:game.value}
        });

        let create = {moduleID:moduleID , assignTo:assigned , name:name , setDate:setDate , dueDate:dueDate , selectedLanguage:language  , vocab:vocab , games:gameObjs };

        return ApplicationServices.call(Constants.CREATE_ASSIGNMENTS , create).then(function(response){
            return response;
        });
    }

    getAllHomework(){
        return ApplicationServices.call(Constants.GET_ALL_HOMEWORK , {} ).then(function(response){
            Actions.update(Constants.UPDATE_ALL_HOMEWORK , response.homework)
        });
    }

    getAssignment(assignmentID){
        return ApplicationServices.call(Constants.GET_HOMEWORK_DETAIL , {assignmentID:assignmentID} ).then(function(response){
            Actions.update(Constants.UPDATE_ASSIGNMENT , response.assignment)
        });
    }

    editHomework(uid , name , assigned ,  setDate , dueDate , language , vocab , games){
        let gameObjs = games.map(function(game){
            return {value:game.value}
        });

        let edit = {uid:uid , assignTo:assigned , name:name , setDate:setDate , dueDate:dueDate , selectedLanguage:language  , vocab:vocab , games:gameObjs };

        return ApplicationServices.call(Constants.EDIT_ASSIGNMENTS , edit).then(function(response){
            return response;
        });
    }

    duplicateHomework(uid , name , assigned ,  setDate , dueDate , language , vocab , games){
        let gameObjs = games.map(function(game){
            return {value:game.value}
        });

        let edit = {uid:uid , assignTo:assigned , name:name , setDate:setDate , dueDate:dueDate , selectedLanguage:language  , vocab:vocab , games:gameObjs };

        return ApplicationServices.call(Constants.DUPLICATE_ASSIGNMENTS , edit).then(function(response){
            return response.homework.uid;
        });
    }

    deleteHomework(homeworkID){
        return ApplicationServices.call(Constants.DELETE_HOMEWORK , {homeworkID:homeworkID}).then(function(response){
            return true;
        });
    }

    getFeatures(){
        return ApplicationServices.call(Constants.GET_HOMEWORK_FEATURES  ,{}).then(function(response){
            Actions.update(Constants.ON_GET_HOMEWORK_FEATURES , response.features)
        });
    }

    make()
    {
        return ApplicationServices.call(HomeworkConstants.MAKE_HOMEWORK , {}).then(function(response){
            return response.homeworkID
        })
    }

    setLanguage(homeworkID , language){

        return ApplicationServices.call(HomeworkConstants.SET_LANGUAGE , {homeworkID:homeworkID , language:language}).then(function(response){
            return response.set
        })

    }

    setVocabularyCatalog(homeworkID , catalog_uids  , active){
        return ApplicationServices.call(HomeworkConstants.SET_CATALOG , {homeworkID:homeworkID , catalogUIDs:catalog_uids }).then(function(response){
            return response
        })
    }

    setHomeworkType(homeworkID , featureID , active){

        return ApplicationServices.call(HomeworkConstants.SET_TYPE , {homeworkID:homeworkID , featureID:featureID , active:active}).then(function(response){
            return response
        })
    }

    setVocabularyGames(homeworkID , games  , vocabNumber){
        return ApplicationServices.call(HomeworkConstants.SET_VOCABULARY_GAMES , {homeworkID:homeworkID , games:games , vocabNumber:vocabNumber}).then(function(response){
            return response
        })
    }

    setName(homeworkID , name){
        return ApplicationServices.call(HomeworkConstants.SET_NAME , {homeworkID:homeworkID , name:name}).then(function(response){
            return response
        })
    }

    setDates(homeworkID , setDTS , dueDTS)
    {
        return ApplicationServices.call(HomeworkConstants.SET_DATES , {homeworkID:homeworkID , dueDTS:dueDTS , setDTS}).then(function(response){
            return response
        })
    }

    setAssigned(homeworkID , assignedClasses)
    {
        return ApplicationServices.call(HomeworkConstants.SET_ASSIGN , {homeworkID:homeworkID , assignedClasses:assignedClasses}).then(function(response){
            return response
        })
    }

    publish(homeworkID){
        return ApplicationServices.call(HomeworkConstants.SET_PUBLISHED , {homeworkID:homeworkID }).then(function(response){
            return response
        })
    }

    getViewableHomework(){
        return ApplicationServices.call(HomeworkConstants.GET_ALL_HOMEWORK , {}).then(function(response){
            Actions.update(HomeworkConstants.ON_VIEWABLE_HOMEWORK_FETCH , response.homework)
        })
    }

}


export default new AssignmentsService();


// WEBPACK FOOTER //
// ./src/services/assignment-services.js